// extracted by mini-css-extract-plugin
export default {"label":"_ab8589fe","customRadio":"_211f3d5a","radio":"_577b4ac9","checked":"_80f60a9f","icon":"_808821d3"};